<template>
    <!-- Publication Details -->
    <div class="pt-4 border-t border-gray-100">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-3">
                <div class="grid grid-cols-2 gap-4">
                    <span class="text-sm font-medium text-gray-500">Nature travail</span>
                    <span class="text-sm text-gray-900 font-mono">{{
                            getAttribut(book.nature_travail)
                        }}</span>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <span class="text-sm font-medium text-gray-500">Section</span>
                    <span class="text-sm text-gray-900">{{ getAttribut(book.section) }}</span>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <span class="text-sm font-medium text-gray-500">Promotion</span>
                    <span class="text-sm text-gray-900">{{ getAttribut(book.promotion) }}</span>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <span class="text-sm font-medium text-gray-500">Note</span>
                    <span class="text-sm text-gray-900">{{ getAttribut(book.notes) }}</span>
                </div>
            </div>

            <div class="space-y-3">
                <div class="grid grid-cols-2 gap-4">
                    <span class="text-sm font-medium text-gray-500">Source</span>
                    <span class="text-sm text-gray-900">{{ getAttribut(book.source) }}</span>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <span class="text-sm font-medium text-gray-500">Pages</span>
                    <span class="text-sm text-gray-900">{{ getAttribut(book.pages) }} pages</span>
                </div>
                <div>
                    <div class="grid grid-cols-2 gap-4">
                        <span class="text-sm font-medium text-gray-500 block mb-2">Format</span>
                        <div class="flex flex-wrap gap-2">
                            <div v-if="Array.isArray(book.type_document)">
                                <span
                                    v-for="type in book.type_document"
                                    class=" bg-blue-50 text-blue-800 px-3 py-1 rounded-full text-xs font-medium"
                                >
                                    {{ type }}
                                </span>
                            </div>
                            <div v-else>
                                <span
                                    class=" bg-blue-50 text-blue-800 px-3 py-1 rounded-full text-xs font-medium"
                                >
                                    {{ book.type_document ?? 'Physique' }}
                                </span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    book: Object
})

const getAttribut = (elem) => {
    return elem ? elem : 'Indisponible'
}
</script>
